import {DojoDeshi} from '../DojoDeshi.js';
import {DojoTemplates} from '../DojoTemplates.js';
import {Eventify} from '../Eventify.js';
import signals from '../lib/signals.js';

export class FormProxyModel {
	constructor(model=null) {
		this.changed = new signals.Signal();
		this.deleted = new signals.Signal();
		this.setSourceModel(model);
	}
	sourceModelChanged(k,v,src) {
		this.changed.dispatch(k,v,src);
	}
	sourceModelDeleted(m) {
		this.changed.dispatch(this);
	}
	setSourceModel(model) {
		if (null!=this.model) {
			this.model.deleted.remove(this.sourceModelDeleted,this);
			this.model.changed.remove(this.sourceModelChanged,this);
		}
		this.model = model;
		this.model.deleted.add(this.sourceModelDeleted,this);
		this.model.changed.add(this.sourceModelChanged,this);

		for (let d in this.model.data) {
			this.changed.dispatch(d, this.model.data[d], this);
		}
	}
	deleteForm() {
		if (null!=this.model)
			this.model.deleteForm();
	}
	setField(name, val, src=null) {
		if (null!=this.model)
			this.model.setField(name,val,src)
	}
	getField(name) {
		if (null==this.model) {
			return undefined;
		}
		return this.model.data[name];
	}
	updateOriginal() {
		if (null!=this.model)
			this.model.updateOriginal();
	}
	get hasChanged() {
		return this.model.hasChanged;
	}
	set hasChanged(h) {
		if (null!=this.model)
			this.model.hasChanged = h;
	}
	reset() {
		if (null!=this.model)
			this.model.reset();
	}
	get Data() {
		if (null==this.model)
			return {};
		return this.model.Data;
	}
	// Only set the Data with data from a remote, unchanged
	// source. After setting the Form's data, the model is considered
	// unchanged.
	set Data(data) {
		if (null!=this.model)
			this.model.Data = data;
	}
}

export class FormModel {
	constructor(data = {}) {
		this.changed = new signals.Signal();
		this.deleted = new signals.Signal();
		this.Data = data;
	}
	deleteForm() {
		this.deleted.dispatch(this);
	}
	setField(name, val, src=null) {
		if (val == this.data[name]) {
			return;
		}
		this.data[name] = val;
		this.hasChanged = true;
		this.changed.dispatch(name,val,this,src);
	}
	getField(name) {
		return this.data[name];
	}
	clone(a) {
		if (null==a) {
			return null;
		}
		let c = {};
		switch (typeof a) {
		case 'object':
			c = {}
			let keys = Object.keys(a);
			for (let i in keys) {
				let k = keys[i];
				c[k] = this.clone(a[k]);
			}
			return c;
		// /** @TODO Apparently 'typeof' will enver return array */
		// case 'array':
		// 	c = [];
		// 	for (let i of a) {
		// 		c[i] = this.clone(a[i]);
		// 	}
		// 	return c;
		}
		return a;
	}
	updateOriginal() {
		this.OriginalData = this.clone(this.data);
		if (this.OriginalData==this.data) {
			console.error('Our objects are the same');
		}
		this.hasChanged = false;
	}
	reset() {
		console.log("Resetting to ", this.OriginalData);
		this.Data = this.OriginalData;
	}
	get Data() {
		return this.data;
	}
	// Only set the Data with data from a remote, unchanged
	// source. After setting the Form's data, the model is considered
	// unchanged.
	set Data(data) {
		this.data = data;
		this.updateOriginal()
		for (let d in this.data) {
			this.changed.dispatch(d, this.data[d], this);
		}
	}
}